var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuildingUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "building-user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.25,
    height: 37,
    viewBox: "0 0 46.25 37",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4504",
    "data-name": "Path 4504",
    d: "M362.406,203.563a5.781,5.781,0,1,0-5.781-5.781A5.781,5.781,0,0,0,362.406,203.563Zm-3.678,2.313A6.73,6.73,0,0,0,352,212.6a2.52,2.52,0,0,0,2.522,2.522H370.29a2.52,2.52,0,0,0,2.522-2.522,6.73,6.73,0,0,0-6.728-6.728Z",
    transform: "translate(-326.563 -178.125)",
    fill: "#888",
    opacity: 0.401
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4505",
    "data-name": "Path 4505",
    d: "M0,3.469A3.47,3.47,0,0,1,3.469,0H24.281A3.47,3.47,0,0,1,27.75,3.469v23.1a9.036,9.036,0,0,0-4.625,7.891A4.8,4.8,0,0,0,23.84,37h-6.5V31.219a3.469,3.469,0,0,0-6.937,0V37H3.469A3.47,3.47,0,0,1,0,33.531ZM5.781,16.188a1.16,1.16,0,0,0-1.156,1.156v2.313a1.16,1.16,0,0,0,1.156,1.156H8.094A1.16,1.16,0,0,0,9.25,19.656V17.344a1.16,1.16,0,0,0-1.156-1.156Zm5.781,1.156v2.313a1.16,1.16,0,0,0,1.156,1.156h2.313a1.16,1.16,0,0,0,1.156-1.156V17.344a1.16,1.16,0,0,0-1.156-1.156H12.719A1.16,1.16,0,0,0,11.563,17.344Zm8.094-1.156A1.16,1.16,0,0,0,18.5,17.344v2.313a1.16,1.16,0,0,0,1.156,1.156h2.313a1.16,1.16,0,0,0,1.156-1.156V17.344a1.16,1.16,0,0,0-1.156-1.156ZM4.625,8.094v2.313a1.16,1.16,0,0,0,1.156,1.156H8.094A1.16,1.16,0,0,0,9.25,10.406V8.094A1.16,1.16,0,0,0,8.094,6.938H5.781A1.16,1.16,0,0,0,4.625,8.094Zm8.094-1.156a1.16,1.16,0,0,0-1.156,1.156v2.313a1.16,1.16,0,0,0,1.156,1.156h2.313a1.16,1.16,0,0,0,1.156-1.156V8.094a1.16,1.16,0,0,0-1.156-1.156ZM18.5,8.094v2.313a1.16,1.16,0,0,0,1.156,1.156h2.313a1.16,1.16,0,0,0,1.156-1.156V8.094a1.16,1.16,0,0,0-1.156-1.156H19.656A1.16,1.16,0,0,0,18.5,8.094Z",
    fill: "#047BC1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuildingUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/building-user.734b7ad3ad3f4deab036b8a101f3e895.svg";